import { OfferFilters } from '@/interfaces/filters/offerFilters';
import { Offer } from '@/interfaces/offer';
import { OfferResource, offerResource } from '@/resources/offer.resource';
import { EntityModule } from '../entity.module';

/**
 * Moduł wniosków klubu
 *
 * @export
 * @class ClubOfferModule
 * @extends {EntityModule<Offer, OfferResource>}
 */
export class ClubOfferModule extends EntityModule<Offer, OfferResource> {
  constructor() {
    super(offerResource);

    const superList = this.actions.list;

    this.actions = {
      ...this.actions,
      /**
       * Pobiera listę encji
       *
       * @param context context
       * @param filters filtry listy
       */
      list: (context: any, filters: OfferFilters): Promise<void> => {
        filters.clubId = context.rootState.club.id;
        return superList(context, filters);
      },
      /**
       * Akceptuje wniosek
       *
       * @param context context
       * @param filters filtry listy
       */
      accept: (context: any, data: { id: number; teamIds: number[] }): Promise<void> => {
        return this.resource.offerAccept(data.id, data.teamIds).then(() => {
          context.commit('remove', data.id);
          context.commit('decrementCount');
        });
      },
      /**
       * Dodaje wniosek
       *
       * @param context context
       * @param data dane do wysłania do API
       */
      add: async (context: any, data: any): Promise<void> => {
        await this.resource.add(data);
        context.commit('add', data);
        context.commit('incrementCount');
      }
    };
  }
}

export default new ClubOfferModule();
